import React, { Component } from 'react';
export default class Header extends Component {
  render() {
    let resumeData = this.props.resumeData;
    return (
      <React.Fragment>
      
      <header id="home">
         <nav id="nav-wrap">
            <a className="mobile-btn" href="#nav-wrap" title="Show navigation" rel='noreferrer'>Show navigation</a>
          <a className="mobile-btn" href="#" title="Hide navigation" rel='noreferrer'>Hide navigation</a>
            <ul id="nav" className="nav">
               <li className="current"><a className="smoothscroll" href="#home" rel='noreferrer'>Home</a></li>
               <li><a className="smoothscroll" href="#about" rel='noreferrer'>About</a></li>
             <li><a className="smoothscroll" href="#resume" rel='noreferrer'>Resume</a></li>
               <li><a className="smoothscroll" href="#portfolio" rel='noreferrer'>Projects</a></li>
               <li><a className="smoothscroll" href="#contact" rel='noreferrer'>Contact</a></li>
            </ul>
         </nav>

         <div className="row banner">
            <div className="banner-text">
               <h1 className="responsive-headline">{resumeData.name}</h1>
               <h3 style={{color:'#fff', fontFamily:'sans-serif '}}>{resumeData.role}{resumeData.roleDescription}
               </h3>
               <hr/>
               <ul className="social">
                  {
                    resumeData.socialLinks && resumeData.socialLinks.map(item =>{
                      return(
                              <li key={item.name}>
                                <a href={item.url} rel="noreferrer" target="_blank"><i className={item.className}></i></a>
                              </li>
                            )
                          }
                    )
                  }
               </ul>
            </div>
         </div>

         <p className="scrolldown">
            <a className="smoothscroll" href="#about" rel='noreferrer'><i className="icon-down-circle"></i></a>
         </p>

      </header>
      </React.Fragment>
    );
  }
}